import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import courses from './CourseData';
import Header from './Header';
import Footer from './Footer';

function CourseDetail() {
  const { slug } = useParams();
  const course = courses.find(c => c.slug === slug);

  const isYouTubeLink = (url) =>
    /(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/))([\w-]{11})/.test(url);

  const getYouTubeEmbedUrl = (url) => {
    const match = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/))([\w-]{11})/);
    return match
      ? `https://www.youtube.com/embed/${match[1]}?modestbranding=1&rel=0&controls=1`
      : null;
  };

  if (!course || course.comingSoon) {
    return <Navigate to="/courses" replace />;
  }

  return (
    <>
      <Header />
      <div className="page-container">
        <h2 className="section-title">{course.title}</h2>
        <p className="section-description">{course.description}</p>

        <h4>Requirements:</h4>
        <ul className="requirement-list">
          {course.requirements.map((req, i) => (
            <li key={i}>{req}</li>
          ))}
        </ul>

        <h4>Course Video:</h4>
        <div className="video-wrapper">
          {course.videoLink ? (
            isYouTubeLink(course.videoLink) ? (
              <iframe
                className="course-video"
                width="100%"
                height="400"
                src={getYouTubeEmbedUrl(course.videoLink)}
                title={course.title}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            ) : (
              <video className="course-video" controls>
                <source src={course.videoLink} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            )
          ) : (
            <p>Video coming soon.</p>
          )}
        </div>

        <h4>Download Template:</h4>
        <a
          href={course.templateLink}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => {
            if (window.gtag) {
              window.gtag('event', 'download', {
                event_category: 'Course',
                event_label: 'DCF Excel Template',
              });
            }
          }}
        >
          <button className="btn-primary">Download Excel Template</button>
        </a>

        {course.overview && (
          <div className="course-overview">
            <h4>Course Overview:</h4>
            <div
              className="overview-content"
              dangerouslySetInnerHTML={{ __html: course.overview }}
            />
          </div>
        )}
      </div>
      <Footer />
    </>
  );
}

export default CourseDetail;